import { useState } from 'react';

type Command = (
  setStatus: (status: CommandStatus) => void,
  ...otherProps: any
) => void;

export type CommandStatus = 'SUCCESS' | 'FAIL' | 'LOADING' | 'INITIAL';

export const useCommand = (
  command: Command,
  initial: CommandStatus = 'INITIAL',
) => {
  const [commandStatus, setCommandStatus] = useState<CommandStatus>(initial);
  const executeCommand = (...props: any) => {
    if (commandStatus === 'INITIAL') {
      setCommandStatus('LOADING');
      command(setCommandStatus, ...props);
    }
  };
  return {
    command: executeCommand,
    commandStatus,
  };
};
